class SSQuickAdd extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    if (!this.button) this.button = this;

    this.variantId = this.button.dataset.variantId;
    this.quantity = this.button.dataset.quantity || 1;
    this.init();
  }

  init() {
    this.button.addEventListener("click", this.handleAddToCart.bind(this));
  }

  handleAddToCart(e) {
    if (this.button.hasAttribute("disabled")) return;

    e.preventDefault();

    this.button.classList.add("loading");

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: this.variantId, quantity: this.quantity }),
    })
      .then((res) => res.json())
      .then(() => {
        this.button.classList.remove("loading");
        document.dispatchEvent(new CustomEvent("cart:updated"));
      })
      .catch((error) => {
        this.button.classList.remove("loading");
        alert("Add to cart failed");
        console.error("Error:", error);
      });
  }
}

if (!customElements.get("ss-quick-add")) {
  customElements.define("ss-quick-add", SSQuickAdd);
}
